// Generischer Slider mit Navigation (statt Scroll-Animation): horizontaler
// scroll-snap-Track + Prev/Next-Buttons + Strich-Indikatoren (Seiten). Genutzt
// von referenzen-carousel und planungsphasen-slider — die Karten-Klasse ist egal
// (Schrittweite misst das erste Track-Kind), die Indikator-Klasse kommt aus
// data-dot-class. Ohne JS bleibt der Track nativ horizontal scrollbar (Nav dann aus).
// Kein Inline-JS (§8).
export function initRefSlider() {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  document.querySelectorAll("[data-refslider]").forEach((root) => {
    const viewport = root.querySelector("[data-refslider-viewport]");
    const track = root.querySelector("[data-refslider-track]");
    const nav = root.querySelector("[data-refslider-nav]");
    const prev = root.querySelector("[data-refslider-prev]");
    const next = root.querySelector("[data-refslider-next]");
    const indicators = root.querySelector("[data-refslider-indicators]");
    if (!viewport) return;

    let pages = 1;

    // Karten pro Schritt: Default 2 (referenzen/planungsphasen); Galerie = 1
    // (ein Slide pro Ansicht) via data-refslider-step.
    const perStep = Math.max(1, parseInt(root.dataset.refsliderStep, 10) || 2);

    const maxScroll = () => viewport.scrollWidth - viewport.clientWidth;
    const scrollable = () => maxScroll() > 2;

    // Schrittweite = perStep Karten (inkl. Gap) -> keine übersprungenen Slides.
    // Erstes Track-Kind = erste Karte (modulunabhängig; ::after ist ein Pseudo).
    const step = () => {
      const card = track.firstElementChild;
      if (!card) return viewport.clientWidth || 1;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return (card.offsetWidth + gap) * perStep;
    };

    const currentPage = () =>
      Math.min(pages - 1, Math.round(viewport.scrollLeft / step()));

    // Weiches Scrollen (Animation). scroll-snap-type wird WÄHREND der Animation
    // ausgesetzt, sonst reißt der Snap den Smooth-Scroll zurück; danach wieder an.
    // Letzter Schritt bis ans Ende -> letzte Karte bündig am Container.
    let snapTimer = 0;
    const scrollToPage = (i) => {
      const target = Math.min(i * step(), maxScroll());
      if (reduce) {
        viewport.scrollLeft = target;
        update();
        return;
      }
      viewport.style.scrollSnapType = "none";
      clearTimeout(snapTimer);
      viewport.scrollTo({ left: target, behavior: "smooth" });
      snapTimer = setTimeout(() => {
        viewport.style.scrollSnapType = ""; // zurück auf CSS (proximity)
      }, 600);
      // Disabled-/Aktiv-Zustand sofort aktualisieren (falls Ziel == aktuelle Position).
      update();
    };

    const build = () => {
      // End-Spacer = linkes Padding − Gap, damit die letzte Karte bündig rechts
      // am Container endet (flex-basis-% ginge hier nicht, s. SCSS).
      if (track) {
        const cs = getComputedStyle(track);
        const pad = parseFloat(cs.paddingInlineStart) || 0;
        const gap = parseFloat(cs.columnGap) || 0;
        track.style.setProperty("--rc-end-spacer", Math.max(0, pad - gap) + "px");
      }
      const on = scrollable();
      pages = on ? Math.ceil(maxScroll() / step()) + 1 : 1;
      if (nav) nav.hidden = !on;
      if (!indicators) return;
      indicators.textContent = "";
      if (!on) return;
      for (let i = 0; i < pages; i++) {
        const b = document.createElement("button");
        b.type = "button";
        b.className = indicators.dataset.dotClass || "referenzen-carousel__indicator";
        b.setAttribute("aria-label", `Seite ${i + 1}`);
        b.addEventListener("click", () => scrollToPage(i));
        indicators.appendChild(b);
      }
    };

    const update = () => {
      if (prev) prev.disabled = viewport.scrollLeft <= 2;
      if (next) next.disabled = viewport.scrollLeft >= maxScroll() - 2;
      if (indicators) {
        const cp = currentPage();
        [...indicators.children].forEach((el, i) =>
          el.classList.toggle("is-active", i === cp),
        );
      }
    };

    if (prev)
      prev.addEventListener("click", () =>
        scrollToPage(Math.max(0, currentPage() - 1)),
      );
    if (next)
      next.addEventListener("click", () =>
        scrollToPage(Math.min(pages - 1, currentPage() + 1)),
      );

    viewport.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", () => {
      build();
      update();
    });
    window.addEventListener("load", () => {
      build();
      update();
    });

    build();
    update();
  });
}
